export default "__VITE_ASSET__DQ49enhF__"